import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPackage, IPackageInitialState } from "./packageModel";
import {
  getAllActivePackages,
  getPackagesByURL,
} from "./services/package.services";

const initialState: IPackageInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  PackageID: null,
  PackageList: [],
  PackageDetail: {
    ID: null,
    PackageTitle: "",
    PackageURL: "",
    PropertyID: null,
    City: "",
    ValidityPeriod: "",
    PackageInclusion: "",
    ChildPolicy: "",
    CancellationPolicy: "",
    CheckinCheckoutInfo: "",
    MetaTitle: "",
    MetaKeywords: "",
    MetaDescription: "",
    Roompricingdetails: [],
    IsActive: 1,
  },
};

const packageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {
    clearPackageDetails: (state) => {
      state.PackageDetail = initialState.PackageDetail;
    },
    setPackageDetail: (state, action: PayloadAction<any>) => {
      state.PackageDetail = action.payload;
      state.loading = false;
    },
    setPackageID: (state, action) => {
      state.PackageID = action.payload;
    },
    clearPackageID: (state) => {
      state.PackageID = initialState.PackageID;
    },
    setPackageList: (state, action: PayloadAction<IPackage[]>) => {
      state.PackageList = action.payload || [];
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPackagesByURL.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getPackagesByURL.fulfilled, (state, action: any) => {
      state.loading = false;
      state.PackageDetail = action.payload;
    });
    builder.addCase(getPackagesByURL.rejected, (state, action) => {
      state.loading = false;
      state.PackageDetail = initialState.PackageDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActivePackages.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActivePackages.fulfilled,
      (state, action: PayloadAction<IPackage[]>) => {
        state.loading = false;
        state.PackageList = action.payload || [];
      },
    );
    builder.addCase(getAllActivePackages.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PackageList = [];
    });
  },
});

export const {
  clearPackageDetails,
  clearPackageID,
  setPackageID,
  setPackageDetail,
  setPackageList,
} = packageSlice.actions;
export default packageSlice.reducer;
